import { FormlyFieldConfig } from '@ngx-formly/core';

const today = new Date();
today.setHours(0, 0, 0, 0); // Rimuovo il tempo dall'oggetto Date per confrontare solo le date

const startDate = new Date(today.setDate(today.getDate() + 9));

const startDate2 = new Date(today.setDate(today.getDate() + 31));

const filterDate = (d: Date | null): boolean => {
    return d !== null && d > startDate;
};

const filterDate2 = (d: Date | null): boolean => {
    return d !== null && d > startDate2;
};

export const RichiestaNullaOstaStep: FormlyFieldConfig[] = [
    {
        fieldGroup: [
            {
                fieldGroupClassName:
                    'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-4 gap-4',
                fieldGroup: [
                    {
                        className: 'sm:col-span-1 md:col-span-3',
                        key: 'jd.occupazione_tipo',
                        type:'mat-select',
                        props: {
                            label: 'TIPO DI OCCUPAZIONE',
                            required: true,
                            options: [
                                {
                                    value: 'b',
                                    label: 'Per manifestazioni varie (piccole rappresentazioni o iniziative pubblicitarie) di durata non superiore a 6 ore;',
                                },
                                {
                                    value: 'c',
                                    label: 'Di durata non superiore a 6 ore per attività di manutenzione del verde anche con mezzi meccanici o automezzi operativi;',
                                },
                                {
                                    value: 'd',
                                    label: 'Di durata non superiore a 12 ore, qualora le stesse riguardino piccoli lavori di manutenzione di infissi, pareti o simili, effettuate con attrezzature idonee;',
                                },
                                {
                                    value: 'e',
                                    label: 'Di durata non superiore a 12 ore per operazioni di trasloco',
                                },
                                {
                                    value: 'f',
                                    label: 'Di durata non superiore a 12 ore per riprese foto-cinetelesive, audio visuali e multimediali',
                                },
                                {
                                    value: 'h',
                                    label: "Per manifestazioni autorizzate dall'amministrazione comunale con apposito atto",
                                },
                            ],
                            change: (field) =>
                                field.parent
                                    .get(`${field.key}_value`)
                                    .formControl.setValue(
                                        (
                                            field.props.options as Array<{
                                                value: any;
                                                label: string;
                                            }>
                                        ).filter(
                                            (x) =>
                                                x.value ==
                                                field.formControl.value,
                                        )[0].label,
                                    ),
                        },
                    },
                    {
                        key: 'jd.occupazione_tipo_value',
                    },
                    {
                        className: 'md:col-span-1 sm:col-span-1',
                        key: 'jd.occupazione_mq',
                        type:'mat-input',
                        props: {
                            label: 'MQ. OCCUPAZIONE',
                            required: true,
                            type: 'number',
                        },
                    },
                    {
                        className: 'xl:col-span-2 sm:col-span-1 md:col-span-3',
                        key: 'jd.oggetto',
                        type:'mat-textarea',
                        defaultValue: '',
                        props: {
                            label: 'MOTIVAZIONI DELLA RICHIESTA',
                            autosize: true,
                            autosizeMaxRows: 8,
                            autosizeMinRows: 2,
                            required: true,
                        },
                    },
                    // {
                    //     className: 'sm:col-span-1 md:col-span-1',
                    //     key: 'jd.autorizzata_dal',
                    //     type: 'mat-datepicker',
                    //     props: {
                    //         label: 'DATA INIZIO',
                    //         datepickerOptions: {
                    //             startAt: startDate,
                    //             filter: filterDate,
                    //         },
                    //     },
                    //     validators: {
                    //         datemin: {
                    //             expression: (c: AbstractControl) =>
                    //                 new Date(c.value) >= startDate,
                    //             message: (
                    //                 error: any,
                    //                 field: FormlyFieldConfig,
                    //             ) =>
                    //                 `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                    //         },
                    //         daterange: {
                    //             expression: (c: AbstractControl) => {
                    //                 const data_dal = new Date(c.value);
                    //                 const data_al = new Date(
                    //                     c.parent?.controls[
                    //                         'autorizzata_al'
                    //                     ]?.value,
                    //                 );
                    //                 return data_dal <= data_al;
                    //             },
                    //             message: (
                    //                 error: any,
                    //                 field: FormlyFieldConfig,
                    //             ) =>
                    //                 'La data di inizio deve essere precedente alla data di fine',
                    //         },
                    //     },
                    // },
                    {
                      className: 'sm:col-span-1 md:col-span-1',
                      key: 'jd.autorizzata_dal',
                      type: '#data',
                      props: {
                        label: 'DATA INIZIO',
                        required: true,
                          datepickerOptions: {
                              startAt: startDate,
                              filter: filterDate,
                          },
                      },
                  },
                    {
                        className: 'xl:col-span-2 sm:col-span-1 md:col-span-2',
                        key: 'jd.occupazione_orario',
                        type: 'mat-input',
                        props: {
                            label: 'ORARIO',
                            required: true,
                        },
                    },
                    {
                        className: 'xl:col-span-2 sm:col-span-1 md:col-span-3',
                        key: 'jd.occupazione_note',
                        type: 'mat-textarea',
                        defaultValue: '',
                        props: {
                            label: 'ALTRE ANNOTAZIONI/ COMMUNICAZIONI',
                            autosize: true,
                            autosizeMaxRows: 8,
                            autosizeMinRows: 2,
                        },
                    },
                ],
            },
        ],
    },
];
